import { RestMethod } from "../../../_helpers/ApiConfig/RestMethod";
import FilterResponse from "../../../_helpers/FilterResponse";
import toastr from "toastr";

export const ContactUsService = {
  contactUs,
  getReachOutList,
  subscribe,
  landingPageSubmit,
  getLandingPageRequest,
  callbackRequest,
};

/**
 *
 * @Vishal
 * For reach out to us
 */
async function contactUs(data) {
  try {
    const response = await RestMethod.POST("/contact-us", data);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response;
  } catch (error) {
    toastr.warning("Failed to submit data. Please try later");
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getReachOutList(offset, limit, queryString, type) {
  var reuestlink = "/all-reach-out?" + queryString;
  if (offset !== null && limit !== null) {
    reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
  }

  if (type) {
    reuestlink = reuestlink + "&type=" + type;
  }

  try {
    const response = await RestMethod.GET(reuestlink);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response.data;
  } catch (error) {
    toastr.error("Something Went Wrong");
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function subscribe(data) {
  try {
    const response = await RestMethod.POST("/subscriber", data);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response.data;
  } catch (error) {
    toastr.warning("Unable to subscribe. Please try later");
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function landingPageSubmit(data) {
  try {
    const response = await RestMethod.POST("/lander-lead", data);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response.data;
  } catch (error) {
    toastr.error("Something Went Wrong");
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function getLandingPageRequest(offset, limit, type) {
  var reuestlink = "/lander-lead-list?type=" + type;
  if (offset !== null && limit !== null) {
    reuestlink = reuestlink + "&limit=" + limit + "&offset=" + offset;
  }

  try {
    const response = await RestMethod.GET(reuestlink);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response.data;
  } catch (error) {
    toastr.error("Something Went Wrong");
    console.log("error detected while fetching data from api");
    return null;
  }
}

async function callbackRequest(data) {
  try {
    const response = await RestMethod.POST("/callback-request", data);
    const api_response = FilterResponse(response); //If respone 200 to 299 Then return
    return api_response;
  } catch (error) {
    toastr.warning("Failed to submit data. Please try later");
    console.log("error detected while fetching data from api");
    return null;
  }
}
